import React, {
  useEffect,
  useState,
  useContext,
  useMemo,
  useCallback
} from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import Pagination from "../../../components/private/pagination";
import "bootstrap/dist/css/bootstrap.min.css";



const TIPOS_CONTRATO = [
  "Fijo",
  "Indefinido",
  "Prestacion de servicios",
  "Obra labor",
];

const ReportePostulaciones = () => {
  const { authFetch, token } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [programas, setProgramas] = useState([]);

  /* ======================
     FILTROS
  ====================== */
  const [filters, setFilters] = useState({
    programa: "",
    tipoContrato: "",
    fechaInicio: "",
    fechaFin: "",
  });

  /* ======================
     PAGINACIÓN
  ====================== */
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  /* ======================
     CARGAR PROGRAMAS
  ====================== */
  useEffect(() => {
  const fetchProgramas = async () => {
    try {
      const res = await authFetch(ENDPOINTS.getprograma);

      if (res.success && res.data) {
        setProgramas(res.data);
      } else {
        setProgramas([]);
      }

    } catch (error) {
      console.error("Error cargando programas:", error);
      setProgramas([]);
    }
  };

  fetchProgramas();
}, [authFetch]);

  /* ======================
     CARGAR DATA (useCallback)
  ====================== */
  const loadReport = useCallback(async () => {
    setLoading(true);
    try {
      const res = await authFetch(ENDPOINTS.getreport);

      if (res.success && Array.isArray(res.data)) {
        setData(res.data);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error cargando reporte:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [authFetch]);

  /* ======================
     EFFECT
  ====================== */
  useEffect(() => {
    if (token) {
      loadReport();
    }
  }, [token, loadReport]);

  /* ======================
     FILTRADO
  ====================== */
  const filteredData = useMemo(() => {
    setCurrentPage(1);

    return data.filter((r) => {
      if (filters.programa && String(r.program_id) !== String(filters.programa)) return false;
      if (filters.tipoContrato && r.type_contract !== filters.tipoContrato) return false;
      if (filters.fechaInicio && r.start_date !== filters.fechaInicio) return false;
      if (filters.fechaFin && r.date_end !== filters.fechaFin) return false;
      return true;
    });
  }, [data, filters]);

  /* ======================
     PAGINACIÓN DATA
  ====================== */
  const totalPages = Math.max(
    1,
    Math.ceil(filteredData.length / recordsPerPage)
  );

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const currentData = filteredData.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  /* ======================
     HANDLERS
  ====================== */
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleExportExcel = () => {
    const params = new URLSearchParams();

    if (filters.programa) params.append("programa", filters.programa);
    if (filters.tipoContrato) params.append("tipo_contrato", filters.tipoContrato);
    if (filters.fechaInicio) params.append("fecha_inicio", filters.fechaInicio);
    if (filters.fechaFin) params.append("fecha_fin", filters.fechaFin);

    window.open(
      `${ENDPOINTS.report_excel}?${params.toString()}`,
      "_blank"
    );
  };

  if (loading) return <p className="m-4">Cargando reporte...</p>;

  /* ======================
     RENDER
  ====================== */
  return (
    <div className="container-fluid mt-4 p-4">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>📊 Reporte gestión humana</h3>
        <button className="btn btn-success" onClick={handleExportExcel}>
          📥 Reporte Excel
        </button>
      </div>

      {/* FILTROS */}
      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3">

            <div className="col-md-3">
              <label className="form-label">Programa</label>
              <select
                className="form-select"
                name="programa"
                value={filters.programa}
                onChange={handleFilterChange}
              >
                <option value="">Todos</option>
                {programas.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label className="form-label">Tipo de contrato</label>
              <select
                className="form-select"
                name="tipoContrato"
                value={filters.tipoContrato}
                onChange={handleFilterChange}
              >
                <option value="">Todos</option>
                {TIPOS_CONTRATO.map((t) => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label className="form-label">Fecha inicio</label>
              <input
                type="date"
                className="form-control"
                name="fechaInicio"
                value={filters.fechaInicio}
                onChange={handleFilterChange}
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">Fecha finalización</label>
              <input
                type="date"
                className="form-control"
                name="fechaFin"
                value={filters.fechaFin}
                onChange={handleFilterChange}
              />
            </div>

          </div>
        </div>
      </div>

      {/* TABLA */}
      <div
        className="table-responsive"
        style={{ maxHeight: "520px", overflow: "auto" }}
      >
        <table className="table table-bordered table-hover mb-0">
          <thead className="table-secondary sticky-top">
            <tr>
              <th>Nombres</th>
              <th>Apellidos</th>
              <th>Cédula</th>
              <th>Cargo</th>
              <th>Salario</th>
              <th>Programa</th>
              <th>Fecha inicio</th>
              <th>Fecha finalización</th>
              <th>EPS</th>
              <th>Pensión</th>
              <th>ARL</th>
              <th>Tipo contrato</th>
              <th>Centro costos</th>
            </tr>
          </thead>

          <tbody>
            {currentData.length > 0 ? (
              currentData.map((r, i) => (
                <tr key={i}>
                  <td>{`${r.first_name} ${r.second_name || ""}`}</td>
                  <td>{`${r.last_name} ${r.second_last_name || ""}`}</td>
                  <td>{r.document}</td>
                  <td>{r.cargo}</td>
                  <td>
                    {r.salary
                      ? `$${Number(r.salary).toLocaleString("es-CO")}`
                      : "-"
                    }
                  </td>
                  <td>{r.program}</td>
                  <td>{r.start_date}</td>
                  <td>{r.date_end || "-"}</td>
                  <td>{r.name_eps}</td>
                  <td>{r.name_pension}</td>
                  <td>{r.arl}</td>
                  <td>{r.type_contract}</td>
                  <td>{r.cost_center}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="13" className="text-center">
                  No hay resultados con los filtros aplicados
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINACIÓN */}
      <div className="mt-3">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={goToPage}
        />
      </div>

    </div>
  );
};

export default ReportePostulaciones;
